import { useParams } from 'react-router-dom';

// helpers
import useNotifications from '../../../../../_lib/notifications/useNotifications';
import { useQuery } from '@tanstack/react-query';
import { Box } from '@mui/material';
// utils
import ChangeInRenewalForm from '../../../../renewals/agency/P100/ChangeInRenewalForm';
import P100ReviewForAccuracy from '../../../../renewals/agency/P100/P100ReviewForAccuracy';
import P100AccountInformation from '../../../../renewals/agency/P100/P100AccountInformation';
import P100RenewalSecurityQuestions from '../../../../renewals/agency/P100/P100RenewalSecurityQuestions';
import P100ContactInformation from '../../../../renewals/agency/P100/P100ContactInformation';
import { QuoteStepLoader } from '../../../../customers/quotes/QuoteStepLoader';
// services
import { fetchQuoteDetails } from '../../../../../inbox/QuotesService';
import { manageAPIError } from '../../../../../utils/error.utils';
import { standaridizeQuoteDetails } from '../../../../renewals/renewal.utils';

import { withShowable } from '../../../../_global/lib/withShowable';
import SecurityQuestionsView from '../../../../_tabs/securityQuestions/SecurityQuestionsView';
import { ProductTypes } from '../../../../../types';
import { BoostRaterVersionResponse } from '../../../quotes/prime-100/api/types';
import {
  getP100QuoteEffectiveDateForRaterPayload,
  resolveP100RaterVersionFromEntity,
} from '../../../quotes/prime-100/utils';

const ReviewForAccuracyMessage = withShowable(P100ReviewForAccuracy);

const P100CustomerRenewalAccountInfoReadOnly = (props: any) => {
  const notifications = useNotifications();

  // @ts-expect-error TS(2339): Property 'quoteId' does not exist on type '{}'.
  const { quoteId } = useParams();

  const { data: quote, isLoading } = useQuery(
    ['quote-details', quoteId],
    async () => {
      try {
        const response = await fetchQuoteDetails(quoteId);
        return {
          ...standaridizeQuoteDetails(response.data),
          effectiveDate: getP100QuoteEffectiveDateForRaterPayload(
            response.data
          ),
          isRenewal: response.data.isRenewal,
          isMigration: response.data.isMigration,
          isAutoRenewal: response.data.isAutoRenewal,
          boostRaterVersion: resolveP100RaterVersionFromEntity(response.data),
        };
      } catch (error) {
        const errorResponse = manageAPIError(error);
        notifications.error(errorResponse);
        throw error;
      }
    },
    {
      keepPreviousData: true,
    }
  );

  const renderP100V6SecurityQuestions =
    Boolean(quoteId) &&
    quote?.boostRaterVersion === BoostRaterVersionResponse.V6;

  if (isLoading) {
    return <QuoteStepLoader />;
  }

  return (
    <div>
      <ReviewForAccuracyMessage show={quote?.isAutoRenewal !== true} />
      <P100AccountInformation data={quote} />
      <P100ContactInformation data={quote} />
      {renderP100V6SecurityQuestions ? (
          <SecurityQuestionsView
            quoteId={quoteId}
            productType={ProductTypes.p100}
            isEditable={false}
          />
        ) : (
          <P100RenewalSecurityQuestions data={quote} />
        )}
      <ChangeInRenewalForm
        data={quote}
        onSubmit={(renewalChangeInAnswers: any) =>
          props.handleVerifyAccountDetails(renewalChangeInAnswers)
        }
      />
    </div>
  );
};

export default P100CustomerRenewalAccountInfoReadOnly;
